import React, { useState } from 'react'
import LinkWithChevron from '../general/LinkWithChevron';


interface Props {
  title: string,
  viewAll?: {
    href: string,
    text: string,
  }
}
const Grid: React.FC<Props> = ({ title, viewAll, children }) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-row items-center justify-between">
        {title && <div className="text-lg font-bold capitalize">{title}</div>}
        {viewAll && <div><LinkWithChevron href={viewAll.href} >{viewAll.text}</LinkWithChevron></div>}
      </div>
      <div className="grid gap-4 lg:gap-8 md:grid-cols-2  xl:grid-cols-3">
        {children}
      </div>
    </div>
  )
}


export default Grid;